import React from "react"

import FeedSlider from "@irati-web/perks/src/components/FeedSlider"
import {useDealList} from "@irati/deals/hooks"
import Loading from "@irati/ui/src/Loading"
import {DealListSort} from "@irati/types"
import authentication from "@irati/auth"

const DealLanes = () => {
  const {load, data} = useDealList({noTt: true, sort: DealListSort.Popularity})
  const hasFP = authentication.apps("wallet.treatTokens")

  return (
    <>
      {hasFP && <FPlane />}
      <Loading load={load}>
        <FeedSlider
          data={data?.results}
          sectionHeaderText="platform.mySavings.dealLanes.allPerks"
          seeMoreUrl="/perks/categories"
        />
      </Loading>
    </>
  )
}

export default DealLanes

const FPlane = () => {
  const {load, data} = useDealList({ttOnly: true, sort: DealListSort.Popularity})
  return (
    <Loading load={load}>
      <FeedSlider
        data={data?.results}
        sectionHeaderText="platform.mySavings.dealLanes.flexiPerks"
        seeMoreUrl="/perks/categories/flexi-perks"
      />
    </Loading>
  )
}
